// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { useState } from 'react';

interface UseKeyboardNavigationProps {
  items: any[];
  handleSelectValue: (value: any) => void;
}

export const useKeyboardNavigation = ({
  items,
  handleSelectValue,
}: UseKeyboardNavigationProps) => {
  const [suggestionIndex, setSuggestionIndex] = useState(-1);
  const sizeItems = items.length;
  const actions = {
    ArrowUp() {
      if (suggestionIndex === -1) return;
      decrementSuggestionIndex();
    },
    ArrowDown() {
      if (suggestionIndex + 1 === sizeItems) return;
      incrementSuggestionIndex();
    },
    Enter() {
      const itemSelected = items[suggestionIndex];
      if (!itemSelected) return;
      handleSelectValue(itemSelected);
      resetSuggestionIndex();
    },
    Backspace() {
      resetSuggestionIndex();
    },
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (sizeItems === 0 || !Object.keys(actions).includes(e.key)) return;

    actions[e.key as keyof typeof actions]();
  };

  const resetSuggestionIndex = () => setSuggestionIndex(-1);
  const incrementSuggestionIndex = () => setSuggestionIndex(suggestionIndex + 1);
  const decrementSuggestionIndex = () => setSuggestionIndex(suggestionIndex - 1);

  return { suggestionIndex, resetSuggestionIndex, handleKeyDown };
};
